import {
  Box,
  Card,
  Checkbox,
  Link,
  Skeleton,
  Title,
} from '@nimbus-ds/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

export function AllowChangePaymentMethodCardSkeleton() {
  const t = useTranslationConfigurations(
    'settingsCheckout.settingsCheckoutForm.allowChangePaymentMethodCard',
  );

  return (
    <Card>
      <Card.Header>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box>
            <Title fontSize="h2">{t('title')}</Title>
          </Box>
        </Box>
      </Card.Header>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="4">
          <Skeleton height="20px" width="112px" />
          <Checkbox.Skeleton width="200px" />
          <Link.Skeleton width="300px" />
        </Box>
      </Card.Body>
    </Card>
  );
}
